import { useContext } from 'react';
import { DialogContext } from '~/contexts';
import { DialogConfig } from '~/contexts/DialogContext/types';

export function useDialog() {
  const { openDialog } = useContext(DialogContext);

  async function getConfirmation({
    ...options
  }: Omit<DialogConfig, 'actionCallback'>): Promise<boolean> {
    return new Promise(res => {
      openDialog({ actionCallback: res, ...options });
    });
  }

  return { getConfirmation };
}
